import { ButtonType, DialogFooterButtonsWidget, DialogPositioningBehavior, DialogType, DialogWidget, TextLinkWidget } from '@tableau/widgets';
import React, { ReactElement } from 'react';

import { Messages } from '~src/codegen/Localize';

const LEGAL_LINK = 'https://www.salesforce.com/company/legal/agreements/';

export interface BetaTermsDialogProps {
  onAccept: () => void;
  onCancel: () => void;
  testId?: string;
}

// Custom Gateway (BYOLLM) Beta terms confirmation dialog. Mirrors AgentBetaWarningDialog:
// a feature-specific disclaimer wrapping DialogWidget with its own copy. The body string
// carries the token 'XXXXXX' marking where the agreement link is spliced in.
export const BetaTermsDialog = ({ onAccept, onCancel, testId = 'BetaTermsDialog' }: BetaTermsDialogProps): ReactElement => {
  const bodySegments = Messages.connectToLLMDialogCustomGatewayBetaTermsBody({ AGREEMENTS_LINK: 'XXXXXX' }).split('XXXXXX');
  const agreementLink = (
    <TextLinkWidget href={LEGAL_LINK} target='_blank' rel='noopener noreferrer' testId={`${testId}_legal_link`}>
      {Messages.connectToLLMDialogCustomGatewayBetaTermsLinkText()}
    </TextLinkWidget>
  );
  return (
    <DialogWidget
      type={DialogType.NormalWithTitleBar}
      title={Messages.connectToLLMDialogCustomGatewayBetaTermsTitle()}
      testId={testId}
      showCloseButton={true}
      onCloseRequest={onCancel}
      dialogWidth={400}
      positioningBehavior={DialogPositioningBehavior.Centered}
      footerContent={<DialogFooterButtonsWidget buttons={[
        {
          buttonType: ButtonType.Outline,
          testId: `${testId}_button_cancel`,
          onClick: onCancel,
          children: Messages.cancel(),
        },
        {
          buttonType: ButtonType.Primary,
          testId: `${testId}_button_accept`,
          onClick: onAccept,
          children: Messages.connectToLLMDialogCustomGatewayBetaTermsAccept(),
        },
      ]} />}
      handleGlassClick={onCancel}
      isModal={true}
    >
      <div>
        {bodySegments[0]}{agreementLink}{bodySegments[1]}
      </div>
    </DialogWidget>
  );
};
